module.exports = __webpack_public_path__ + "66bf50f3fa6503d1fe7ace116a1eb150.jpg";